export const translations = {
    de: {
        nav: {
            home: 'Startseite',
            modules: 'Module',
            lessons: 'Lektionen',
            quizzes: 'Quiz',
            progress: 'Fortschritt',
            settings: 'Einstellungen',
            manageContent: 'fintogo Unterrichts-Editor',
            liveQuiz: 'fintogo Klassenraum',
        },
        modules: {
            title: 'Module',
            lessons: 'Lektionen',
            exercises: 'Übungen',
            duration: 'Dauer',
            points: 'Punkte',
            noModules: 'Keine Module verfügbar',
            class: 'Klasse',
            semester: 'Semester',
            selectModule: 'Wähle ein Modul',
            selectModuleDesktop: 'Wähle ein Modul aus der Seitenleiste',
            selectModuleMobile: 'Wähle ein Modul aus dem Dropdown-Menü',
            loadError: 'Fehler beim Laden der Module',
            backToModule: 'Zurück zum Modul',
            lessonsInModule: 'Lektionen in diesem Modul',
            lessonSingular: 'Lektion',
            lessonPlural: 'Lektionen',
            moduleLoading: 'Modul wird geladen…',
            moduleLoadError: 'Modul konnte nicht geladen werden.',
            unknownError: 'Unbekannter Fehler beim Laden des Moduls.',
            tryAgainLater: 'Bitte versuche es später erneut oder kontaktiere den Admin.',
            backToLessons: 'Zurück zu den Lektionen',
            completeAndNext: 'Nächste Lektion',
            completeLesson: 'Lektion abgeschlossen',
            finishModule: 'Modul abschließen',
            lessonOf: 'Lektion {{current}} von {{total}}',
            back: 'Zurück',
            congratulations: '🎉 Herzlichen Glückwunsch! 🎉',
            moduleCompleted: 'Modul abgeschlossen!',
            moduleCompletedText: 'Du hast das Modul <strong>{{title}}</strong> erfolgreich abgeschlossen.',
            lessonsCompleted: 'Lektionen',
            quizzesAvailable: 'Quiz verfügbar',
            quizzesForModule: 'Quiz zu diesem Modul:',
            backToModule: 'Zurück zum Modul',
            goToDashboard: 'Zum Dashboard',
            startQuiz: 'Quiz starten',
        },
        quizzes: {
            title: 'Quiz & Tests',
            subtitle: 'Teste dein Wissen mit interaktiven Quiz zu den Modulen. Sammle Punkte und verfolge deinen Fortschritt!',
            activeModule: 'Aktives Modul',
            completed: 'Quiz absolviert',
            average: 'Durchschnitt',
            pointsEarned: 'Punkte verdient',
            bestPerformance: 'Beste Leistung',
            all: 'Alle',
            practice: 'Übung',
            searchQuiz: 'Quiz suchen...',
            allCategories: 'Alle Kategorien',
            questions: 'Fragen',
            timeLimit: 'Zeitlimit',
            startQuiz: 'Quiz starten',
            minutes: 'min',
            tries: 'Versuche:',
            bestpoints: 'Beste Punktzahl:',
            retry: "Erneut versuchen",
        },
        lessons: {
            title: 'Lektionen',
            start: 'Starten',
            continue: 'Fortsetzen',
            completed: 'Abgeschlossen',
            locked: 'Gesperrt',
            learninggoals: 'Lernziele:',
            theory: 'Theorie',
            lesson: 'Lektion',
            of: 'von',
        },
        quiz: {
            title: 'Quiz',
            loading: 'Quiz wird geladen…',
            error_loading: 'Quiz konnte nicht geladen werden.',
            completed: 'Geschafft!',
            of: 'von',
            questions_correct: 'Fragen richtig',
            points: 'Punkte',
            correct: 'Richtig!',
            incorrect: 'Leider falsch.',
            back_to_overview: 'Zurück zur Übersicht',
            already_completed_title: 'Dieses Quiz hast du bereits absolviert.',
            already_completed_text: 'Du kannst das Quiz nicht erneut starten.',
            start_description: 'Quiz zum Modul „{{module}}". Dieses Quiz kann nur einmal absolviert werden.',
            questions: 'Fragen',
            time_limit: 'Zeitlimit',
            average_points: 'Durchschnittliche Punkte',
            start_button: 'Quiz starten',
            your_answer: 'Deine Antwort',
            in_unit: 'in {{unit}}',
            enter_answer: 'Antwort eingeben',
            choose: '-- Wählen --',
            question_of: 'Frage {{current}} von {{total}}',
            question: 'Frage',
            ai_loading: 'KI-Erklärung wird geladen...',
            ai_explanation: 'KI-Erklärung:',
            no_explanation: 'Keine Erklärung verfügbar.',
            explanation_error: 'Fehler beim Abrufen der Erklärung.',
            solution: 'Lösung:',
            check_answer: 'Antwort prüfen',
            next_question: 'Nächste Frage',
            finish_quiz: 'Quiz beenden',
            ai_system_prompt: 'Du bist ein hilfreicher Tutor für Rechnungswesen in Österreich.\nEin Student hat eine Frage beantwortet und die Antwort war falsch.\nErkläre kurz und verständlich, warum die Antwort falsch ist und was die korrekte Antwort ist.\nNutze Markdown für bessere Lesbarkeit (fett, kursiv, Listen, Code wenn nötig).',
            start: 'Quiz starten',
            submit: 'Absenden',
            next: 'Nächste Frage',
            previous: 'Vorherige Frage',
            score: 'Punkte',
            total_questions: "Anzahl Fragen",
            partial: "Teilweise Richtig!",
        },
        dashboard: {
            readyForLesson: 'Bereit für eine weitere Lerneinheit?',
            yourLessons: 'Deine Lektionen',
            viewAll: 'Alle anzeigen',
            inProgress: 'In Bearbeitung',
            notStarted: 'Nicht begonnen',
            repeat: 'Wiederholen',
            noLessons: 'Noch keine Lektionen',
            startFirstLesson: 'Starte deine erste Lektion und beginne deine Lernreise!',
            discoverLessons: 'Lektionen entdecken',
            openQuizzes: 'Offene Quiz',
            allQuizzes: 'Alle Quiz',
            allQuizzesDone: 'Alle Quiz erledigt!',
            noOpenQuizzes: 'Super, du hast derzeit keine offenen Quiz.',
            open: 'Offen',
            quizForLesson: 'Quiz zur Lektion',
            recentQuizResults: 'Letzte Quiz-Ergebnisse',
            correct: 'richtig',
            noQuizCompleted: 'Noch keine Quiz absolviert',
            testKnowledge: 'Teste dein Wissen und sammle Punkte!',
            daysStreak: 'Tage Streak',
        },
        common: {
            loading: 'Lädt...',
            error: 'Fehler',
            save: 'Speichern',
            cancel: 'Abbrechen',
            close: 'Schließen',
            back: 'Zurück',
            continue: 'Weiter',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            confirm: 'Bestätigen',
            welcomeBack: 'Willkommen zurück',
            noSelection: 'keine Auswahl',
            part: 'Teil',
            unit: 'Einheit',
        },
        aiChat: {
            title: 'fintogo Lerncoach',
            messagePlaceholder: 'Schreibe deine Nachricht...',
            questionPlaceholder: 'Frage stellen...',
            noAnswer: 'Keine Antwort erhalten.',
            error: 'Fehler beim Abrufen der Antwort.',
        },
        auth: {
            login: 'Anmelden',
            logout: 'Abmelden',
            register: 'Registrieren',
            email: 'E-Mail',
            password: 'Passwort',
            forgotPassword: 'Passwort vergessen?',
        },
        teacher: {
            dashboard: 'Lehrer Dashboard',
            class: 'Klasse:',
            school: 'Schule:',
            noClassAssigned: 'Keine Klasse zugewiesen',
            noSchool: 'Keine Schule',
            quizzesCompleted: 'Quiz absolviert',
            averagePerformance: 'Klassen Durschnitt',
            pointsCollected: 'Klassen Gesamtpunkte',
            bestPerformance: 'Beste Leistung',
            studentsInClass: 'Schüler in Ihrer Klasse',
            noStudentsFound: 'Keine Schüler gefunden',
            noStudentsInClass: 'In der Klasse "{className" sind noch keine Schüler registriert.',
            noClassAssignedText: 'Sie haben keine Klasse zugewiesen bekommen.',
            rank: '#',
            name: 'Name',
            points: 'Punkte',
            level: 'Level',
            quizzesDone: 'Quiz absolviert',
            average: 'Durchschnitt',
            loadingDashboard: 'Dashboard wird geladen...',
            noUserFound: 'Kein Benutzer gefunden',
            pleaseLogin: 'Bitte melden Sie sich an.',
            reload: 'Neu laden',
        },
        contentCreator: {
            title: 'fintogo Unterrichts-Editor',
            subtitle: 'Module, Lektionen und Quiz erstellen und bearbeiten',
            newModule: 'Neues Modul',
            loadError: 'Fehler beim Laden der Module',
            deleteError: 'Fehler beim Löschen',
            noModules: 'Noch keine Module vorhanden',
            createFirst: 'Erstellen Sie Ihr erstes Modul, um loszulegen.',
            noDescription: 'Keine Beschreibung',
            lessonsInModule: 'Lektionen:',
            more: 'weitere',
            addLesson: 'Lektion hinzufügen',
            editQuiz: 'Quiz bearbeiten',
            confirmDelete: 'Löschen bestätigen',
            deleteModuleConfirm: 'Möchten Sie dieses Modul wirklich löschen? Alle Lektionen und Quiz werden ebenfalls gelöscht.',
            createModule: 'Modul erstellen',
            editModule: 'Modul bearbeiten',
            moduleId: 'Modul-ID',
            generate: 'Generieren',
            idRequired: 'ID ist erforderlich',
            idInvalid: 'ID darf nur Buchstaben, Zahlen und Unterstriche enthalten',
            titleRequired: 'Titel ist erforderlich',
            moduleTitle: 'Titel',
            yearLevel: 'Jahrgang/Klasse',
            semester: 'Semester',
            orderIndex: 'Reihenfolge',
            orderHint: 'Bestimmt die Anzeigereihenfolge der Module',
            description: 'Beschreibung',
            descriptionPlaceholder: 'Kurze Beschreibung des Moduls...',
            idHint: 'Eindeutige ID, z.B. M1_WR_1K für Modul 1 Wirtschaftliches Rechnen Klasse 1',
            moduleNotFound: 'Modul nicht gefunden',
            moduleCreated: 'Modul erfolgreich erstellt',
            moduleSaved: 'Modul erfolgreich gespeichert',
            saveError: 'Fehler beim Speichern',
            createLesson: 'Lektion erstellen',
            editLesson: 'Lektion bearbeiten',
            lessonId: 'Lektions-ID',
            lessonTitle: 'Titel',
            lessonDescPlaceholder: 'Kurze Beschreibung der Lektion...',
            category: 'Kategorie',
            difficulty: 'Schwierigkeit',
            duration: 'Dauer (min)',
            points: 'Punkte',
            order: 'Reihenfolge',
            basicInfo: 'Grundinformationen',
            learningObjectives: 'Lernziele',
            newObjectivePlaceholder: 'Neues Lernziel eingeben...',
            contentSections: 'Inhaltsabschnitte',
            addSection: 'Abschnitt',
            noSections: 'Noch keine Abschnitte. Klicken Sie oben auf "Abschnitt" um zu beginnen.',
            lessonNotFound: 'Lektion nicht gefunden',
            lessonCreated: 'Lektion erfolgreich erstellt',
            lessonSaved: 'Lektion erfolgreich gespeichert',
            untitledSection: 'Unbenannter Abschnitt',
            editMode: 'Bearbeiten',
            preview: 'Vorschau',
            moveUp: 'Nach oben',
            moveDown: 'Nach unten',
            sectionTitle: 'Abschnitt-Titel',
            sectionTitlePlaceholder: 'z.B. 1.1 Einführung',
            sectionId: 'Abschnitt-ID',
            markdownContent: 'Inhalt (Markdown)',
            markdownPlaceholder: 'Markdown-Text eingeben...\n\n**Fett**, *kursiv*, Listen mit - oder 1.',
            markdownHint: 'Unterstützt Markdown: **fett**, *kursiv*, Listen, Links',
            exerciseCount: 'Übungen',
            totalPoints: 'Gesamtpunkte',
            addExercise: 'Übung hinzufügen',
            typeInput: 'Texteingabe',
            typeSingleChoice: 'Single Choice',
            typeDropdown: 'Dropdown/Lückentext',
            noExercises: 'Noch keine Übungen',
            addFirstExercise: 'Fügen Sie die erste Übung hinzu',
            quizPreview: 'Quiz-Vorschau',
            exercisesSaved: 'Quiz erfolgreich gespeichert',
            backToLesson: 'Zur Lektion',
            untitledExercise: 'Unbenannte Übung',
            exerciseId: 'Übungs-ID',
            exerciseType: 'Typ',
            exerciseTitle: 'Titel',
            timeLimit: 'Zeit (s)',
            prompt: 'Aufgabenstellung',
            promptPlaceholder: 'Die Frage oder Aufgabenstellung...',
            solution: 'Lösungsweg (für Anzeige)',
            solutionPlaceholder: 'Erklärung der Lösung...',
            typeConfig: 'Typ-spezifische Konfiguration',
            correctAnswer: 'Richtige Antwort',
            answerFormat: 'Format',
            tolerance: 'Toleranz',
            unit: 'Einheit',
            acceptedAnswers: 'Alternative Antworten',
            addAlternative: 'Alternative hinzufügen',
            choices: 'Antwortmöglichkeiten',
            addChoice: 'Antwort hinzufügen',
            textSegments: 'Text-Segmente (zwischen Lücken)',
            textSegmentsPlaceholder: 'Ein Segment pro Zeile. Nach jedem Segment kommt eine Lücke.',
            textSegmentsHint: 'Jede Zeile ist ein Textteil. Nach jedem Teil kommt ein Dropdown.',
            blanks: 'Lücken (Dropdowns)',
            blank: 'Lücke',
            addOption: 'Option',
            addBlank: 'Lücke hinzufügen',
            tags: 'Tags (kommagetrennt)',
            aiGenerator: 'KI-Inhaltsgenerator',
            aiGeneratorDesc: 'Laden Sie ein PDF hoch und lassen Sie KI Module und Quiz erstellen',
            model: 'KI-Modell',
            uploadPdf: 'PDF-Datei hochladen',
            clickToUpload: 'Klicken Sie hier oder ziehen Sie eine PDF-Datei hierher',
            onlyPdfAllowed: 'Nur PDF-Dateien sind erlaubt',
            selectPdfFirst: 'Bitte wählen Sie zuerst eine PDF-Datei aus',
            apiKeyRequired: 'OpenRouter API-Schlüssel ist erforderlich',
            getApiKey: 'Holen Sie sich einen Schlüssel von',
            extractingPdf: 'PDF wird extrahiert...',
            analyzingContent: 'Inhalt wird mit KI analysiert...',
            processingResult: 'Ergebnis wird verarbeitet...',
            generationComplete: 'Generierung abgeschlossen!',
            generating: 'Generiere...',
            generateContent: 'Inhalte generieren',
            generationFailed: 'Generierung fehlgeschlagen',
            apiError: 'API-Fehler. Überprüfen Sie Ihren API-Schlüssel.',
            pdfExtractionFailed: 'PDF konnte nicht gelesen werden.',
            parseError: 'AI-Antwort konnte nicht verarbeitet werden.',
            previewGenerated: 'Generierte Inhalte',
            savedSuccessfully: 'Erfolgreich gespeichert!',
            lessons: 'Lektionen',
            sections: 'Abschnitte',
            exercises: 'Übungen',
            saveAll: 'Alle speichern',
            saveFailed: 'Speichern fehlgeschlagen',
            manageButton: 'fintogo Unterrichts-Editor',
        },
        liveQuiz: {
            connection: "Verbindung wird hergestellt...",
            questionOf: "Frage {{current}} / {{total}}",
            answered: "{{count}}/{{total}} geantwortet",
            result: "Ergebnis",
            correct: "Richtig",
            votes: "{{count}} Stimmen",
            leaderboard: "Zwischenstand",
            pts: "Pkt.",
            points: "Punkte",
            nextQuestionSoon: "Nächste Frage kommt gleich...",
            quizFinished: "Quiz beendet!",
            finalResult: "Endergebnis",
            quizRunning: "fintogo Klassenraum läuft:",
            rejoinAsHost: "Als Host zurück →",
            inviteTitle: "fintogo Klassenraum Einladung",
            inviteTeacher: "Dein Lehrer",
            inviteStarts: "startet:",
            decline: "Ablehnen",
            joinNow: "Jetzt Beitreten →",
            waitingRoom: "Warteraum",
            roomCode: "Raum-Code:",
            studentsJoined: "{{count}} Schüler beigetreten",
            startQuiz: "Quiz starten ({{count}} Spieler)",
            rejoin: "Wieder beitreten →",
            waitingForTeacher: "Warte auf den Lehrer...",
            teacherEnded: "Der Lehrer hat das Quiz beendet.",
            answeredSubmitted: "✅ Antwort abgegeben - warte auf Ergebnis...",
            pointsEarned: "+{{delta}} Punkte!",
            wrong: "Falsch!",
            total: "Gesamt",
            backToHome: "Zurück zur Startseite",
            noQuizzes: "Keine Quizze für dieses Modul gefunden.",
            invalidResponseFormat: "Ungültiges Antwortformat vom Server.",
            loadError: "Quizze konnten nicht geladen werden.",
            questions: "{{count}} Fragen",
            selectClass: "Klasse auswählen...",
            creatingRoom: "Erstelle Raum...",
            createRoom: "Klassenraum erstellen",
            teacherStarted: "hat einen fintogo Klassenraum gestartet!",
            playNow: "Jetzt mitspielen",
            playersConnected: "{{count}} Spieler verbunden",
            correctAnswer: "Richtige Antwort",
            totalPoints: "Gesamtpunkte",
            yourFinalScore: "Dein Endergebnis",
            pageSubtitle: "Starte einen fintogo Klassenraum für deine Klasse",
            selectModule: "Modul auswählen",
            noModule: "Kein Modul verfügbar.",
            createModule: "Modul erstellen",
            questions: "{{count}} Fragen",
        }
    },
    en: {
        nav: {
            home: 'Home',
            modules: 'Modules',
            lessons: 'Lessons',
            quizzes: 'Quizzes',
            progress: 'Progress',
            settings: 'Settings',
            manageContent: 'fintogo Content-Manager',
            liveQuiz: 'fintogo classroom',
        },
        modules: {
            title: 'Modules',
            lessons: 'Lessons',
            exercises: 'Exercises',
            duration: 'Duration',
            points: 'Points',
            noModules: 'No modules available',
            class: 'Class',
            semester: 'Semester',
            selectModule: 'Select a module',
            selectModuleDesktop: 'Select a module from the sidebar',
            selectModuleMobile: 'Select a module from the dropdown menu',
            loadError: 'Error loading modules',
            backToModule: 'Back to Module',
            lessonsInModule: 'Lessons in this Module',
            lessonSingular: 'Lesson',
            lessonPlural: 'Lessons',
            moduleLoading: 'Loading module…',
            moduleLoadError: 'Could not load module.',
            unknownError: 'Unknown error loading module.',
            tryAgainLater: 'Please try again later or contact the admin.',
            backToLessons: 'Back to Lessons',
            completeAndNext: 'Next Lesson',
            completeLesson: 'Lesson completed',
            finishModule: 'Finish Module',
            lessonOf: 'Lesson {{current}} of {{total}}',
            back: 'Back',
            congratulations: '🎉 Congratulations! 🎉',
            moduleCompleted: 'Module completed!',
            moduleCompletedText: 'You have successfully completed the module <strong>{{title}}</strong>.',
            lessonsCompleted: 'Lessons',
            quizzesAvailable: 'Quizzes available',
            quizzesForModule: 'Quizzes for this module:',
            backToModule: 'Back to Module',
            goToDashboard: 'Go to Dashboard',
            startQuiz: 'Start Quiz',
        },
        quizzes: {
            title: 'Quiz & Tests',
            subtitle: 'Test your knowledge with interactive quizzes on the modules. Collect points and track your progress!',
            activeModule: 'Active Module',
            completed: 'Quiz completed',
            average: 'Average',
            pointsEarned: 'Points earned',
            bestPerformance: 'Best performance',
            all: 'All',
            practice: 'Practice',
            searchQuiz: 'Search quiz...',
            allCategories: 'All Categories',
            questions: 'Questions',
            timeLimit: 'Time limit',
            startQuiz: 'Start Quiz',
            minutes: 'min',
            tries: 'Tries:',
            bestpoints: 'Most Points:',
            retryQuiz: "Retry Quiz",
        },
        lessons: {
            title: 'Lessons',
            start: 'Start lesson',
            continue: 'Continue',
            completed: 'Completed',
            locked: 'Locked',
            learninggoals: 'Learning goals:',
            theory: 'Theory',
            lesson: 'lesson',
            of: 'of',
        },
        quiz: {
            title: 'Quiz',
            loading: 'Loading quiz…',
            error_loading: 'Could not load quiz.',
            completed: 'Completed!',
            of: 'of',
            questions_correct: 'questions correct',
            points: 'Points',
            correct: 'Correct!',
            incorrect: 'Unfortunately incorrect.',
            back_to_overview: 'Back to overview',
            already_completed_title: 'You have already completed this quiz.',
            already_completed_text: 'You cannot start the quiz again.',
            start_description: 'Quiz for module "{{module}}". This quiz can only be completed once.',
            questions: 'Questions',
            time_limit: 'Time limit',
            average_points: 'Average points',
            start_button: 'Start quiz',
            your_answer: 'Your answer',
            in_unit: 'in {{unit}}',
            enter_answer: 'Enter answer',
            choose: '-- Choose --',
            question_of: 'Question {{current}} of {{total}}',
            question: 'Question',
            ai_loading: 'Loading AI explanation...',
            ai_explanation: 'AI Explanation:',
            no_explanation: 'No explanation available.',
            explanation_error: 'Error retrieving explanation.',
            solution: 'Solution:',
            check_answer: 'Check answer',
            next_question: 'Next question',
            finish_quiz: 'Finish quiz',
            ai_system_prompt: 'You are a helpful tutor for accounting in Austria.\nA student answered a question and the answer was incorrect.\nExplain briefly and clearly why the answer is wrong and what the correct answer is.\nUse Markdown for better readability (bold, italic, lists, code if necessary).',
            start: 'Start Quiz',
            submit: 'Submit',
            next: 'Next question',
            previous: 'Previous question',
            score: 'Score',
            total_questions: "Total Questions",
            partial: "Partially Right!",
        },
        dashboard: {
            readyForLesson: 'Ready for another learning session?',
            yourLessons: 'Your Lessons',
            viewAll: 'View all',
            inProgress: 'In Progress',
            notStarted: 'Not Started',
            repeat: 'Repeat',
            noLessons: 'No lessons yet',
            startFirstLesson: 'Start your first lesson and begin your learning journey!',
            discoverLessons: 'Discover Lessons',
            openQuizzes: 'Open Quizzes',
            allQuizzes: 'All Quizzes',
            allQuizzesDone: 'All quizzes completed!',
            noOpenQuizzes: 'Great, you currently have no open quizzes.',
            open: 'Open',
            quizForLesson: 'Quiz for lesson',
            recentQuizResults: 'Recent Quiz Results',
            correct: 'correct',
            noQuizCompleted: 'No quizzes completed yet',
            testKnowledge: 'Test your knowledge and collect points!',
            daysStreak: 'Days Streak',
        },
        common: {
            loading: 'Loading...',
            error: 'Error',
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            back: 'Back',
            continue: 'Continue',
            edit: 'Edit',
            delete: 'Delete',
            confirm: 'Confirm',
            welcomeBack: 'Welcome back',
            noSelection: 'no selection',
            part: 'Part',
            unit: 'Unit',
        },        aiChat: {
            title: 'fintogo learning coach',
            messagePlaceholder: 'Write your message...',
            questionPlaceholder: 'Ask a question...',
            noAnswer: 'No answer received.',
            error: 'Error retrieving answer.',
        },        auth: {
            login: 'Login',
            logout: 'Logout',
            register: 'Register',
            email: 'Email',
            password: 'Password',
            forgotPassword: 'Forgot Password?',
        },
        teacher: {
            dashboard: 'Teacher Dashboard',
            welcomeBack: 'Welcome back,',
            class: 'Class:',
            school: 'School:',
            noClassAssigned: 'No class assigned',
            noSchool: 'No school',
            quizzesCompleted: 'Quizzes Completed',
            averagePerformance: 'Class Average',
            pointsCollected: 'Class Total Points',
            bestPerformance: 'Best Performance',
            studentsInClass: 'Students in Your Class',
            noStudentsFound: 'No Students Found',
            noStudentsInClass: 'There are no students registered in class "{className}" yet.',
            noClassAssignedText: 'You have not been assigned a class.',
            rank: '#',
            name: 'Name',
            points: 'Points',
            level: 'Level',
            quizzesDone: 'Quizzes Done',
            average: 'Average',
            loadingDashboard: 'Loading dashboard...',
            noUserFound: 'No user found',
            pleaseLogin: 'Please log in.',
            reload: 'Reload',
        },
        contentCreator: {
            title: 'Manage Content',
            subtitle: 'Create and edit modules, lessons, and quizzes',
            newModule: 'New Module',
            loadError: 'Error loading modules',
            deleteError: 'Error deleting',
            noModules: 'No modules yet',
            createFirst: 'Create your first module to get started.',
            noDescription: 'No description',
            lessonsInModule: 'Lessons:',
            more: 'more',
            addLesson: 'Add Lesson',
            editQuiz: 'Edit Quiz',
            confirmDelete: 'Confirm Delete',
            deleteModuleConfirm: 'Are you sure you want to delete this module? All lessons and quizzes will also be deleted.',
            createModule: 'Create Module',
            editModule: 'Edit Module',
            moduleId: 'Module ID',
            generate: 'Generate',
            idRequired: 'ID is required',
            idInvalid: 'ID can only contain letters, numbers, and underscores',
            titleRequired: 'Title is required',
            moduleTitle: 'Title',
            yearLevel: 'Year Level',
            semester: 'Semester',
            orderIndex: 'Order',
            orderHint: 'Determines the display order of modules',
            description: 'Description',
            descriptionPlaceholder: 'Brief description of the module...',
            idHint: 'Unique ID, e.g. M1_WR_1K for Module 1 Business Math Class 1',
            moduleNotFound: 'Module not found',
            moduleCreated: 'Module created successfully',
            moduleSaved: 'Module saved successfully',
            saveError: 'Error saving',
            createLesson: 'Create Lesson',
            editLesson: 'Edit Lesson',
            lessonId: 'Lesson ID',
            lessonTitle: 'Title',
            lessonDescPlaceholder: 'Brief description of the lesson...',
            category: 'Category',
            difficulty: 'Difficulty',
            duration: 'Duration (min)',
            points: 'Points',
            order: 'Order',
            basicInfo: 'Basic Information',
            learningObjectives: 'Learning Objectives',
            newObjectivePlaceholder: 'Enter new learning objective...',
            contentSections: 'Content Sections',
            addSection: 'Section',
            noSections: 'No sections yet. Click "Section" above to get started.',
            lessonNotFound: 'Lesson not found',
            lessonCreated: 'Lesson created successfully',
            lessonSaved: 'Lesson saved successfully',
            untitledSection: 'Untitled Section',
            editMode: 'Edit',
            preview: 'Preview',
            moveUp: 'Move Up',
            moveDown: 'Move Down',
            sectionTitle: 'Section Title',
            sectionTitlePlaceholder: 'e.g. 1.1 Introduction',
            sectionId: 'Section ID',
            markdownContent: 'Content (Markdown)',
            markdownPlaceholder: 'Enter Markdown text...\n\n**Bold**, *italic*, lists with - or 1.',
            markdownHint: 'Supports Markdown: **bold**, *italic*, lists, links',
            exerciseCount: 'Exercises',
            totalPoints: 'Total Points',
            addExercise: 'Add Exercise',
            typeInput: 'Text Input',
            typeSingleChoice: 'Single Choice',
            typeDropdown: 'Dropdown/Fill-in-blank',
            noExercises: 'No exercises yet',
            addFirstExercise: 'Add your first exercise',
            quizPreview: 'Quiz Preview',
            exercisesSaved: 'Quiz saved successfully',
            backToLesson: 'Back to Lesson',
            untitledExercise: 'Untitled Exercise',
            exerciseId: 'Exercise ID',
            exerciseType: 'Type',
            exerciseTitle: 'Title',
            timeLimit: 'Time (s)',
            prompt: 'Question',
            promptPlaceholder: 'The question or task...',
            solution: 'Solution (for display)',
            solutionPlaceholder: 'Explanation of the solution...',
            typeConfig: 'Type-specific Configuration',
            correctAnswer: 'Correct Answer',
            answerFormat: 'Format',
            tolerance: 'Tolerance',
            unit: 'Unit',
            acceptedAnswers: 'Alternative Answers',
            addAlternative: 'Add Alternative',
            choices: 'Answer Options',
            addChoice: 'Add Answer',
            textSegments: 'Text Segments (between blanks)',
            textSegmentsPlaceholder: 'One segment per line. A blank follows each segment.',
            textSegmentsHint: 'Each line is a text part. A dropdown follows each part.',
            blanks: 'Blanks (Dropdowns)',
            blank: 'Blank',
            addOption: 'Option',
            addBlank: 'Add Blank',
            tags: 'Tags (comma-separated)',
            aiGenerator: 'AI Content Generator',
            aiGeneratorDesc: 'Upload a PDF and let AI create modules and quizzes',
            model: 'AI Model',
            uploadPdf: 'Upload PDF file',
            clickToUpload: 'Click here or drag a PDF file here',
            onlyPdfAllowed: 'Only PDF files are allowed',
            selectPdfFirst: 'Please select a PDF file first',
            apiKeyRequired: 'OpenRouter API key is required',
            getApiKey: 'Get a key from',
            extractingPdf: 'Extracting PDF...',
            analyzingContent: 'Analyzing content with AI...',
            processingResult: 'Processing result...',
            generationComplete: 'Generation complete!',
            generating: 'Generating...',
            generateContent: 'Generate Content',
            generationFailed: 'Generation failed',
            apiError: 'API error. Check your API key.',
            pdfExtractionFailed: 'Could not read PDF.',
            parseError: 'Could not process AI response.',
            previewGenerated: 'Generated Content',
            savedSuccessfully: 'Saved successfully!',
            lessons: 'Lessons',
            sections: 'Sections',
            exercises: 'Exercises',
            saveAll: 'Save All',
            saveFailed: 'Save failed',
            manageButton: 'fintogo Content-Manager',
        },
        liveQuiz: {
            connecting: "Connecting...",
            questionOf: "Question {{current}} / {{total}}",
            answered: "{{count}}/{{total}} answered",
            result: "Result",
            correct: "Correct",
            votes: "{{count}} votes",
            leaderboard: "Leaderboard",
            pts: "pts",
            points: "Points",
            nextQuestionSoon: "Next question coming up...",
            quizFinished: "Quiz finished!",
            finalResult: "Final Result",
            quizRunning: "fintogo classroom running:",
            rejoinAsHost: "Rejoin as Host →",
            inviteTitle: "fintogo classroom Invitation",
            inviteTeacher: "Your teacher",
            inviteStarts: "is starting:",
            decline: "Decline",
            joinNow: "Join Now →",
            waitingRoom: "Waiting Room",
            roomCode: "Room Code:",
            studentsJoined: "{{count}} students joined",
            startQuiz: "Start Quiz ({{count}} players)",
            rejoin: "Rejoin →",
            waitingForTeacher: "Waiting for the teacher...",
            teacherEnded: "The teacher has ended the quiz.",
            answerSubmitted: "✅ Answer submitted - waiting for result...",
            pointsEarned: "+{{delta}} Points!",
            wrong: "Wrong!",
            total: "total",
            backToHome: "Back to Home",
            noQuizzes: "No quizzes found for this module.",
            invalidResponseFormat: "Invalid response format from server.",
            loadError: "Could not load quizzes.",
            question: "{{count}} questions",
            selectClass: "Select class...",
            creatingRoom: "Creating room...",
            createRoom: "Create classroom",
            teacherStarted: "has started a fintogo classroom!",
            playNow: "Play now",
            playersConnected: "{{count}} players connected",
            correctAnswer: "Correct answer",
            totalPoints: "Total points",
            YourFinalScore: "Your final score",
            pageSubtitle: "Start a fintogo classroom for your class",
            selectModule: "Select module",
            noModule: "No module available.",
            createModule: "Create module",
            questions: "{{count}} questions",
        }
    }
};
